module.exports = __webpack_public_path__ + "assets/1d4f40e9004bd501c92b34ad2dff3a65.json";